import React from 'react';
import clsx from 'clsx';
import {TextField} from '@material-ui/core';
import PropTypes from 'prop-types';
import inputComponent from './inputComponent';
const Control = React.forwardRef(function Control(props, ref) {
   const {
      children,
      innerProps,
      innerRef,
      selectProps: {classes, TextFieldProps}
   } = props;
   function inputToUpperCase(e) {
      if (props.selectProps.inputMayuscula) {
         e.target.value = e.target.value.toUpperCase();
      }
   }
   return (
      <TextField
         ref={ref}
         fullWidth
         onKeyUp={inputToUpperCase}
         InputProps={{
            inputComponent,
            inputProps: {
               className: classes.input,
               ref: innerRef,
               children,
               ...innerProps
            }
         }}
         {...TextFieldProps}
      />
   );
});

Control.propTypes = {
   /**
    * Children to render.
    */
   children: PropTypes.node,
   /**
    * The mouse down event and the innerRef to pass down to the controller element.
    */
   innerProps: PropTypes.shape({
      onMouseDown: PropTypes.func.isRequired
   }).isRequired,
   innerRef: PropTypes.oneOfType([
      PropTypes.oneOf([null]),
      PropTypes.func,
      PropTypes.shape({
         current: PropTypes.any.isRequired
      })
   ]).isRequired,
   selectProps: PropTypes.object.isRequired
};
export default Control;
